import { Box, Button } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Modal from "../../components/dialog/Modal";
import ScrollableTabs from "../../components/tabs/Tabs";
import { getForms } from "../../state/actions/FormsActions";
import { getGroups } from "../../state/actions/GroupActions";
import { getObjectives } from "../../state/actions/ObjectiveActions";
import { getPriceLists } from "../../state/actions/PriceListsActions";
import { getMustSellSkus } from "../../state/actions/MustSellActions";
import { getCustomerFlags } from "../../state/actions/CustomerFlagActions";
import { getDashboardLayouts } from "../../state/actions/DashboardLayoutActions";
import { ContentPicker } from "../content-picker/ContentPicker";
import GenericPicker from "../generic-picker/GenericPicker";
import { withTranslation } from "react-i18next";
import { ObjectiveType } from "../../state/constants/ObjectiveConstants";

class ContentPickerModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selection: []
    }
  }

  render() {
    let { selection } = this.state;
    const handleSelection = newSelection => {
      this.setState({ selection: newSelection });
    };


    return (
      <Modal
        title={this.props.t('campaign.target-content')}
        open={this.props.open}
        fullWidth={true}
        fixedHeight={true}
        actions={
          <div>
            <Button color="secondary" onClick={() => {
              this.props.handleCancel()
              this.setState({ selection: [] });
            }}>
              {this.props.t('common.cancel')}
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                this.props.handleDone(selection);
                this.setState({ selection: [] });
              }}
            >
              {this.props.t('common.done')}
            </Button>
          </div>
        }
      >
        <Box style={{ position: "relative", width: "100%", height: "100%" }}>
          <ScrollableTabs
            isSticky
            tabs={
              [
                {
                  name: this.props.t('picker.media'),
                  content: <ContentPicker
                    handleSelection={handleSelection}
                    cols={this.props.cols}
                    spacing={this.props.spacing}
                    cellHeight={this.props.cellHeight}
                    selected={this.props.selected}
                    currentSelection={selection}
                  />
                },
                {
                  name: this.props.t('must-sell.must-sell-skus'),
                  content: <GenericPicker
                    selected={this.props.selected}
                    handleSelection={handleSelection}
                    getAllData={(callback) => this.props.getMustSellSkus(callback)}
                    searchTitle={this.props.t('must-sell.must-sell-skus')}
                    data={Object.values(this.props.mustSells)}
                    idField="id"
                    valueField="Name"
                    secondaryFields={["id"]}
                    currentSelection={selection}
                  />
                },
                {
                  name: this.props.t('product-group.product-groups'),
                  content: <GenericPicker
                    selected={this.props.selected}
                    handleSelection={handleSelection}
                    getAllData={(callback) => this.props.getGroups(callback)}
                    searchTitle={this.props.t('product-group.product-groups')}
                    data={Object.values(this.props.groups)}
                    idField="id"
                    valueField="Name"
                    secondaryFields={["id"]}
                    currentSelection={selection}
                  />
                },
                {
                  name: this.props.t('form.forms'),
                  content: <GenericPicker
                    selected={this.props.selected}
                    handleSelection={handleSelection}
                    getAllData={(callback) => this.props.getForms(callback)}
                    searchTitle={this.props.t('form.forms')}
                    data={Object.values(this.props.forms)}
                    idField="id"
                    valueField="Name"
                    secondaryFields={["id"]}
                    currentSelection={selection}
                  />
                },
                {
                  name: this.props.t('objective.objectives'),
                  content: <GenericPicker
                    selected={this.props.selected}
                    handleSelection={handleSelection}
                    getAllData={(callback) => this.props.getObjectives([ObjectiveType().admin.key], callback)}
                    searchTitle={this.props.t('objective.objectives')}
                    data={Object.values(this.props.objectives)}
                    idField="id"
                    valueField="Title"
                    secondaryFields={["id"]}
                    currentSelection={selection}
                  />
                },
                {
                  name: this.props.t('customer-flag.customer-flags'),
                  content: <GenericPicker
                    selected={this.props.selected}
                    handleSelection={handleSelection}
                    getAllData={(callback) => this.props.getCustomerFlags(callback)}
                    searchTitle={this.props.t('customer-flag.customer-flags')}
                    data={Object.values(this.props.customerFlags)}
                    idField="id"
                    valueField="Name"
                    secondaryFields={["id", "SuperList"]}
                    currentSelection={selection}
                  />
                },
                {
                  name: this.props.t('price-list.price-lists'),
                  content: <GenericPicker
                    selected={this.props.selected}
                    handleSelection={handleSelection}
                    getAllData={(callback) => this.props.getPriceLists(false, callback)}
                    searchTitle={this.props.t('price-list.price-lists')}
                    data={Object.values(this.props.priceLists)}
                    idField="id"
                    valueField="Name"
                    secondaryFields={["id"]}
                    currentSelection={selection}
                  />
                },
                {
                  name: this.props.t('dashboard-layout.dashboard-layouts'),
                  content: <GenericPicker
                    selected={this.props.selected}
                    handleSelection={handleSelection}
                    getAllData={(callback) => this.props.getDashboardLayouts(callback)}
                    searchTitle={this.props.t('dashboard-layout.dashboard-layouts')}
                    data={Object.values(this.props.dashboardLayouts)}
                    idField="id"
                    valueField="id"
                    secondaryFields={["id"]}
                    currentSelection={selection}
                  />
                }
              ]
            } />
        </Box>
      </Modal>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { files } = state.FileDownloadReducer;
  const { groups } = state.GroupReducer;
  const { mustSells } = state.MustSellReducer;
  const { forms } = state.FormsReducer;
  const { objectives } = state.ObjectivesReducer;
  const { customerFlags } = state.CustomerFlagReducer;
  const { priceLists } = state.PriceListsReducer;
  const { dashboardLayouts } = state.DashboardLayoutReducer;
  return {
    files,
    mustSells,
    groups,
    forms,
    objectives,
    customerFlags,
    priceLists,
    dashboardLayouts
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getGroups,
  getForms,
  getMustSellSkus,
  getObjectives,
  getCustomerFlags,
  getPriceLists,
  getDashboardLayouts
}, dispatch);

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ContentPickerModal))
);

// EXPORT COMPONENT

export { hoc as ContentPickerModal };

